var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('Modal', {
    staticClass: "valid_password",
    attrs: {
      "width": "500",
      "footer-hide": "",
      "closable": false,
      "mask-closable": false
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "pa-tip"
  }, [_c('Icon', {
    staticClass: "icon-tip",
    attrs: {
      "type": "ios-alert"
    }
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v($t("2pkvm6i", "您已经很久没改过密码了，请修改密码！"))])], 1), _c('div', {
    staticClass: "footer"
  }, [_c('Button', {
    staticClass: "vp-cancel",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(` ${$t("ev022", "取消")} `)]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onUpdate
    }
  }, [_vm._v(` ${$t("jtq3wu6", "立即修改密码")} `)])], 1)])]), _c('UpdatePassword', {
    ref: "updatePassword",
    on: {
      "on-success": _vm.onSuccessUpdate
    }
  }), _c('passwordModal', {
    ref: "passwordModalRef",
    on: {
      "cancel": _vm.cancelSetpassword,
      "confirm": _vm.confirmSetpassword
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };